import { ListingType } from "@enums/listingType";
import { ProjectStatus } from "@enums/projectStatus";
import { ProjectType } from "@enums/projectType";
import defaultImage from "@images/shared/profile-default.png";
import { IProject } from "@interfaces/project";
import { IProjectFeatured } from "@interfaces/projectFeatured";
import { TProjectDto } from "types/Project/projectDto";
import { timestampToString } from "./dates.format";
import {
  booleanToString,
  getCapitalizedFirstChar,
  getCategoriesFromArray,
} from "./string";

export const projectStatusMap = {
  [ProjectStatus.LAUNCHED]: "Launched",
  [ProjectStatus.PENDING]: "Pending",
  [ProjectStatus.SOLD_OUT]: "Sold Out",
};

export const projectTypeMap = {
  [ProjectType.Edition]: "Edition",
  [ProjectType.OneOfOne]: "One of one",
};

export const listingTypeMap = {
  [ListingType.PRIVATE_LISTING]: "Private",
  [ListingType.PUBLIC_LISTING]: "Public",
};

export const apiProjectToDto = ({
  name,
  artist,
  projectType,
  listingType,
  contractData,
  maxSupply,
  status,
  banned,
  createdAt,
  category,
  tagCollection,
  description,
  isPhysicalPiece,
  provenanceCertificateUrl,
  bannerUrl,
  mintPrice,
  royalties,
  featured,
}: IProject): TProjectDto => ({
  name,
  artist,
  projectType: projectTypeMap[projectType],
  listingType: listingTypeMap[listingType],
  network: getCapitalizedFirstChar(contractData.network),
  maxSupply,
  status: projectStatusMap[status],
  banned: booleanToString(banned),
  createdAt: timestampToString(createdAt),
  category: getCategoriesFromArray(category),
  tagCollection,
  description,
  isPhysicalPiece: booleanToString(isPhysicalPiece),
  provenanceCertificateUrl,
  bannerUrl: bannerUrl ?? defaultImage,
  mintPrice,
  mintAddress: contractData.mintAddress,
  tokenAddress: contractData.tokenAddress,
  contractType: contractData.contractType,
  royalties,
  featured: getProjectFeaturedAsString(featured),
});

export const getProjectFeaturedAsString = (featured?: IProjectFeatured) => {
  return featured?.featuredOrder && featured?.featuredType
    ? `${featured.featuredOrder} - ${featured.featuredType?.toUpperCase()}`
    : "-";
};
